/**
 * 用户信息
 */
// token
export const TOKEN = "token";
export const TOKEN_INFO = "tokenInfo";
// refresh_token
export const REFRESH_TOKEN = "refreshToken";
// token 时间戳
export const TOKEN_TIME = "tokenTime";
// 用户ID
export const USER_ID = "userId";
// 用户信息
export const USER_INFO = "userInfo";
// 用户菜单
export const USER_MENU = "userMenu";
// 企业信息
export const ENTERPRISE_INFO = "enterpriseInfo";
// 用户企业信息
export const USER_ENTERPRISE_INFO = "userEnterpriseInfo";
// 购物车
export const SHOP_CART = "shopCart";
// 测算表单选项结果
export const EVALUATION_FORM = "evaluationForm";
/**
 * 字典信息
 */
// 字典类型
export const DICT_TYPE = "dict_type";
// 地区
export const DISTRICT = "district";
// 行业
export const INDUSTRY = "industry";
export const SCALE_INDUSTRY = "scaleIndustry";
// 技术领域
export const DOMAIN = "domain";
// 标签
export const TAG_DATA = "tagData";
// 年份
export const POLICY_YEAR = "policyYear";
// 供应类型
export const SUPPLY_TYPE = "supplyType";
// 需求类型
export const DEMAND_TYPE = "demandType";
// 服务类型
export const SERVICE_CLASS_LIST = "serviceClassList";
// 服务方式
export const SERVICE_MODE_LIST = "serviceModeList";
// 服务对象
export const SERVICE_OBJECT_LIST = "serviceObjectList";
// 系统定位
export const SYSTEM_LOCAL = "systemLocal";
/* 
  其他
*/
export const REVIEW_RESULT = "reviewResult";